import { ref } from 'vue';
import axios from 'axios';

export default function useUtility() {
  const academicYearList = ref([]);
  const hasRoomsInColleagueList = ref([]);
  const isBuildingInColleague = ref(false);
  const roomRateClasses = ref([]);
  const roomRateTables = ref([]);
  const terms = ref([]);

  const getAcademicYears = async () => {
    if (academicYearList.value.length === 0) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/academicYears`);
        academicYearList.value = response.data;
      } catch (error) {
        console.log(error);
      }
    }
  };

  const deleteBlobDocument = async (blobId) => {
    try {
      await axios.delete(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/deleteBlobDocument/${blobId}`);
    } catch (error) {
      console.log(error);
    }
  };

  const getBlobDocument = async (blobId) => {
    try {
      const response = await axios.get(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/getBlobDocument/${blobId}`, {
        responseType: 'blob',
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
    return null;
  };

  const getLoggingExport = async () => {
    try {
      const result = await axios.get(
        `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/loggingExport`,
      );

      return result.data;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const getEmailHistoryExport = async () => {
    try {
      const result = await axios.get(
        `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/emailHistoryExport`,
      );

      return result.data;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const getRoomRateClasses = async () => {
    if (roomRateClasses.value.length === 0) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/roomRateClasses`);
        roomRateClasses.value = response.data;
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getRoomRateTables = async () => {
    if (roomRateClasses.value.length === 0) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/roomRateTables`);
        roomRateTables.value = response.data;
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getTerms = async () => {
    if (terms.value.length === 0) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/terms`);
        terms.value = response.data;
      } catch (error) {
        console.log(error);
      }
    }
  };

  const hasBuildingInColleague = async (complexCode) => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/hasBuildingInColleague`;
      const response = await axios.get(url,
        {
          params: {
            complexCode,
          },
        });
      isBuildingInColleague.value = response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const hasRoomsInColleague = async (unitName, complexCode) => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/hasRoomsInColleague`;
      const response = await axios.get(url,
        {
          params: {
            unitName,
            complexCode,
          },
        });
      hasRoomsInColleagueList.value = response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const updateToDigiPenEmailsAndEapStatus = async (sessionId) => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/updateToDigiPenEmailsAndEapStatus/${sessionId}`;
      await axios.put(url);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    academicYearList,
    deleteBlobDocument,
    getAcademicYears,
    getBlobDocument,
    getEmailHistoryExport,
    getLoggingExport,
    getRoomRateClasses,
    getRoomRateTables,
    getTerms,
    hasBuildingInColleague,
    hasRoomsInColleague,
    hasRoomsInColleagueList,
    isBuildingInColleague,
    roomRateClasses,
    roomRateTables,
    terms,
    updateToDigiPenEmailsAndEapStatus,
  };
}
